export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/dark-info.9654079e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};